import { render, staticRenderFns } from "./DepartCheck.vue?vue&type=template&id=33900cea&scoped=true"
import script from "./DepartCheck.vue?vue&type=script&lang=js"
export * from "./DepartCheck.vue?vue&type=script&lang=js"
import style0 from "./DepartCheck.vue?vue&type=style&index=0&id=33900cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33900cea",
  null
  
)

export default component.exports